import { Component, Input, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { finalize, Subject, takeUntil } from 'rxjs';
import { CoachCalendarService } from '../../../core/services/coach-calendar.service';
import { IRescheduleRequest } from '../../../core/models/appointment.model';

@Component({
  selector: 'coach-reject-reschedule-modal',
  templateUrl: './reject-reschedule-modal.component.html',
  styleUrl: './reject-reschedule-modal.component.scss',
})
export class RejectRescheduleModalComponent implements OnDestroy {
  @Input() request!: IRescheduleRequest;

  fg: FormGroup = this.formBuilder.group({
    note: [null, [Validators.maxLength(1000)]],
  });

  isLoading = false;

  destroyed$ = new Subject();

  constructor(
    public modal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private calendarService: CoachCalendarService,
  ) {
  }

  onSubmit() {
    this.isLoading = true;
    this.calendarService.rejectRescheduleRequest(this.request.id, this.fg.value.note ?? undefined)
      .pipe(takeUntil(this.destroyed$), finalize(() => this.isLoading = false))
      .subscribe(() => {
        this.modal.close(true);
      });
  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
